<template>
  <h1 class="font-bold text-3xl mb-4">Login to your account</h1>

  <!-- Google Login Button -->
  <GoogleLoginButton />

  <!-- Divider -->
  <div class="relative my-6">
    <div class="absolute inset-0 flex items-center">
      <div class="w-full border-t border-gray-300"></div>
    </div>
    <div class="relative flex justify-center text-sm">
      <span class="px-2 bg-white text-gray-500">Or continue with email</span>
    </div>
  </div>

  <!-- Email/Password Form -->
  <FormKit type="form" @submit="handleSubmit" submit-label="Login">
    <FormKit type="email" placeholder="Email" name="email"></FormKit>
    <FormKit type="password" placeholder="Password" name="password"></FormKit>
  </FormKit>

  In case you don't have an account yet <RouterLink to="registration" class="text-secondary font-bold">create one here</RouterLink>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { useLsGeneralStore } from '../stores/application'
import { errorNotification, successNotification } from '@/utils/notifications'
import GoogleLoginButton from '../components/GoogleLoginButton.vue'

const store = useLsGeneralStore()
const router = useRouter()
const handleSubmit = (data: { email: string; password: string }) => {
  store
    .login(data.email, data.password)
    .then(() => {
      successNotification('Logged in')
      router.push({ name: 'home' })
    })
    .catch(e => {
      console.log(e)
      errorNotification(e.response?.data.error)
    })
}
</script>
